export const ACCSETTING_LOADING = "ACCSETTING_LOADING";
export const ACCSETTING_RESET = "ACCSETTING_RESET";
export const GET_ACCSETTING = "GET_ACCSETTING";
export const GET_ACCSETTING_SUCCESS = "GET_ACCSETTING_SUCCESS";
export const GET_ACCSETTING_FAIL = "GET_ACCSETTING_FAIL";
export const DELETE_ACCSETTING = "DELETE_ACCSETTING"
export const DELETE_ACCSETTING_SUCCESS = "DELETE_ACCSETTING_SUCCESS"
export const DELETE_ACCSETTING_FAIL = "DELETE_ACCSETTING_FAIL"
export const UPDATE_ACCSETTING = "UPDATE_ACCSETTING"
export const UPDATE_ACCSETTING_SUCCESS = "UPDATE_ACCSETTING_SUCCESS"
export const UPDATE_ACCSETTING_FAIL = "UPDATE_ACCSETTING_FAIL"
export const ADD_NEW_ACCSETTING = "ADD_NEW_ACCSETTING"
export const ADD_ACCSETTING_SUCCESS = "ADD_ACCSETTING_SUCCESS"
export const ADD_ACCSETTING_FAIL = "ADD_ACCSETTING_FAIL"